import * as angular from 'angular';
import {IController} from 'angular';

import {ExpenseCategoryStatus} from "../../types/expenses-category-status.type";

export class ExpensesCategoryStatusSelectListComponent implements IController {


  selectedId: any;
  ngPlaceholder: any;
  onChange: Function;

  private statuses: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.statuses =  Object.values(ExpenseCategoryStatus)
  }


}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCategoryStatusSelectList', {
    bindings: {
      selectedId: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./expenses-category-status-select-list.html').default,
    controller: ExpensesCategoryStatusSelectListComponent
  });
